/**
 * 环境配置文件
 * 根据NODE_ENV动态加载对应的服务器配置
 */

// 导入服务器配置
import { testServer, productServer } from './servers';

// 环境配置
const environments = {
  development: {
    name: 'development',
    apiBaseUrl: `http://${testServer.ip}:9090/api/cus/union/user`,
    serverIp: testServer.ip,
    description: '开发环境 - 使用测试服务器'
  },
  test: {
    name: 'test',
    apiBaseUrl: `http://${testServer.ip}:9090/api/cus/union/user`,
    serverIp: testServer.ip,
    description: '测试环境 - 使用测试服务器'
  },
  production: {
    name: 'production',
    apiBaseUrl: `http://${productServer.ip}:9090/api/cus/union/user`,
    serverIp: productServer.ip,
    description: '生产环境 - 使用生产服务器'
  }
};

// 获取当前环境配置
const getCurrentEnvironment = () => {
  const env = process.env.NODE_ENV || 'development';
  console.log('🌍 当前环境变量:', process.env.NODE_ENV);
  console.log('🌍 解析的环境:', env);
  
  // 明确的环境判断
  if (env === 'production') {
    console.log('🌍 使用生产环境配置');
    return environments.production;
  } else if (env === 'test') {
    console.log('🌍 使用测试环境配置');
    return environments.test;
  } else {
    console.log('🌍 使用开发环境配置');
    return environments.development;
  }
};

// 导出配置
export const config = getCurrentEnvironment();

// 导出环境信息
export const environment = {
  isDevelopment: process.env.NODE_ENV === 'development',
  isTest: process.env.NODE_ENV === 'test',
  isProduction: process.env.NODE_ENV === 'production',
  current: process.env.NODE_ENV || 'development'
};

// 导出所有环境配置（用于调试）
export const allEnvironments = environments;

// 默认导出当前配置
export default config; 